<script setup>

import { inject, ref, computed } from 'vue';
import ListeTypesObjet from './listeTypesObjet/ListeTypesObjet.vue';
import DetailTypeObjet from './detailTypeObjet/DetailTypeObjet.vue';
import ListeChamps from './listeChamps/ListeChamps.vue';
import DetailChamp from './detailChamp/DetailChamp.vue';
import ModaleEditionTypeObjet from '@/components/modales/ModaleEditionTypeObjet.vue';
import ModaleEditionChamp from '@/components/modales/ModaleEditionChamp.vue';

const { typesObjet } = defineProps({
  typesObjet: Array
});

const selectionSchema = inject('selectionSchema');

const typeObjetEdite = ref(null);
const champEdite = ref(null);

const premierChampSelectionne = computed(() => {
	const champsSelectionnes = selectionSchema.value.champs;
	if (champsSelectionnes.length > 0) {
		return champsSelectionnes[0];
	} else {
		return null;
	}
});

function afficherModaleEditionTypeObjet(typeObjet) {
	typeObjetEdite.value = typeObjet;
}

function fermerModaleEditionTypeObjet() {
	typeObjetEdite.value = null;
}

function afficherModaleCreationChamp(typeObjet) {
	champEdite.value = {idTypeObjet: typeObjet.id};
}

function afficherModaleEditionChamp(champ) {
	champEdite.value = champ;
}

function fermerModaleEditionChamp() {
	champEdite.value = null;
}

</script>

<template>
	<div class="panel-lateral contenu-onglet-schema">
		<ListeTypesObjet :types-objet="typesObjet" />
		<DetailTypeObjet 
			:type-objet="selectionSchema.typeObjet"
			@edition-type-objet="(typeObjet) => afficherModaleEditionTypeObjet(typeObjet)" />
		<ListeChamps 
			:type-objet="selectionSchema.typeObjet"
			@creation-champ="(typeObjet) => afficherModaleCreationChamp(typeObjet)" />
		<DetailChamp 
			:type-objet="selectionSchema.typeObjet" 
			:champ="premierChampSelectionne"
			@edition-champ="(champ) => afficherModaleEditionChamp(champ)" />
		<ModaleEditionTypeObjet 
			v-if="typeObjetEdite"
			:type-objet-edite="typeObjetEdite"
			@fermeture="fermerModaleEditionTypeObjet" />
		<ModaleEditionChamp 
			v-if="champEdite"
			:champ-edite="champEdite"
			@fermeture="fermerModaleEditionChamp" />
	</div>
</template>

<style scoped>
</style>